export function PortalHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl text-white">{title}</h1>
        {subtitle && <p className="text-[#A1A1AA] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ icon: Icon, text, testid }) {
  return (
    <div className="text-center py-16 rounded-2xl border border-dashed border-white/10 bg-[#0f0f11]" data-testid={testid}>
      {Icon && <Icon className="w-10 h-10 text-[#52525B] mx-auto mb-3" />}
      <p className="text-[#71717A]">{text}</p>
    </div>
  );
}

export const fmtDate = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return ""; }
};

export const fmtBytes = (n) => {
  if (!n) return "0 B";
  const k = 1024, sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(n) / Math.log(k));
  return `${(n / k ** i).toFixed(1)} ${sizes[i]}`;
};
